import * as Application from 'expo-application';
import Constants from 'expo-constants';
import * as Updates from 'expo-updates';
import { Platform } from 'react-native';

import { type LaunchDarklyContext } from '@sg/launch-darkly';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Latest JS bundle app version.
 *
 * NOTE: If an OTA is applied, the version will be the
 *       version of it and not the initial version.
 *
 * NOTE: See `NATIVE_APP_VERSION` for the initial version.
 */
const BUNDLE_APP_VERSION = Constants.expoConfig?.version ?? '0.0.0';

const NATIVE_APP_VERSION =
  Platform.select({
    // NOTE: On web, we use the bundle/latest version since there is no OTA concept there.
    web: BUNDLE_APP_VERSION,
    default: Application.nativeApplicationVersion,
  }) ?? '0.0.0';

/**
 * From Expo docs:
 *
 * "This will be `true` if the currently running update is the one embedded
 *  in the build, and not one downloaded from the updates server."
 *
 * NOTE: It's always `true` on the web platform, since there is no OTA concept there.
 */
const IS_EMBEDDED_LAUNCH = Platform.select({
  web: true,
  native: Updates.isEmbeddedLaunch,
});

export const APP_CONTEXT: LaunchDarklyContext = {
  name: 'Order',
  platform: Platform.OS,
  version: BUNDLE_APP_VERSION,
  nativeAppVersion: NATIVE_APP_VERSION,
  isEmbeddedLaunch: IS_EMBEDDED_LAUNCH,
};

/**
 * @deprecated Use `app` context kind instead.
 */
export const legacy_CUSTOM_ATTRIBUTES: LaunchDarklyContext = {
  platform: Platform.OS,
  appVersion: BUNDLE_APP_VERSION,
};
